import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter as Router } from "react-router-dom";
import { UserProvider } from "./components/user/UserContext";
import { ToastProvider } from "./components/Toast/ToastContext";
import { ThemeProvider } from "./components/Theme/ThemeContext";
import { LoadScript } from "@react-google-maps/api";
import config from "./config";
import { loadPlanLimits } from "./utils/planLimits";
const googleMapsAPIKey = config.googleMapsAPIKey ?? "";

// What each plan allows is read inside renders, which cannot await. Fetched
// once here so the answer is in memory before it is asked for; until it lands
// the shipped defaults are used, so a slow response delays nothing.
loadPlanLimits();

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <React.StrictMode>
    <Router>
      <LoadScript googleMapsApiKey={googleMapsAPIKey} libraries={["places"]}>
        <ThemeProvider>
          <UserProvider>
            <ToastProvider>
              <App />
            </ToastProvider>
          </UserProvider>
        </ThemeProvider>
      </LoadScript>
    </Router>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
